import type { ApiResponse } from '@fluenceur/types';
import { useQuery } from '@tanstack/react-query';
import api from '@/libs/axiosInstance';
import type { InvitableProgramResponse } from '@/types/affiliate-programs';
import type { CustomQueryHookOptions } from '@/types/query-options';

export const fetchInvitablePrograms = async (
  creatorId: string
): Promise<InvitableProgramResponse[]> => {
  const response = await api.get<ApiResponse<InvitableProgramResponse[]>>(
    `/dashboard/creators/${creatorId}/invitable-programs`
  );

  if (response.data.success === false || !response.data.data) {
    throw new Error(response.data.message ?? 'Failed to fetch invitable programs');
  }

  return response.data.data;
};

const invitableProgramsQueryKey = (creatorId: string) => ['invitablePrograms', creatorId];

export const useFetchInvitablePrograms = (
  creatorId: string,
  options?: CustomQueryHookOptions<InvitableProgramResponse[], Error>
) => {
  return useQuery<InvitableProgramResponse[], Error>({
    ...options,
    queryKey: invitableProgramsQueryKey(creatorId),
    queryFn: () => fetchInvitablePrograms(creatorId),
  });
};
